/* ============================================================
   MAISON SAHARI v2 — vie sobre : apparitions au défilement + nuancier vivant.
   Remplace assets/maison-sahari.js (chargé en defer par layout/theme.liquid).

   Règles de sûreté :
   - Les états « avant apparition » n'existent que sous html.ms-ready, classe posée ICI, après avoir
     marqué les éléments (.ms-io) et branché l'observateur. Fichier non chargé, erreur, navigateur
     sans IntersectionObserver, prefers-reduced-motion et éditeur de thème : rien n'est jamais masqué.
   - Aucun minuteur qui révèle tout d'un coup : une apparition ne se joue que lorsque l'élément entre à l'écran.
   - Seuls opacity et translate bougent : aucun décalage de mise en page (CLS 0).
   ============================================================ */
(function () {
  'use strict';
  var html = document.documentElement;
  var reduce = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  var design = !!(window.Shopify && window.Shopify.designMode);

  /* ---------- 1. Apparitions : [sélecteur, cascade ?] — jamais le héros (LCP) ni l'en-tête ---------- */
  var GROUPS = [
    ['.ms-mani__inner', false],
    ['.section-resource-list__header', false],
    ['.section-resource-list .resource-list__item', true],
    ['.ms-look__head', false],
    ['.ms-look__tile', true],
    ['.ms-jour__head', false],
    ['.ms-jour__item', true],
    ['.ms-jour__follow', false],
    ['.ms-feat:not(.ms-feat--hero) .ms-feat__text', false],
    ['.ms-val__col', true],
    ['.ms-faq__head', false],
    ['.ms-faq__list', false],
    ['.ms-wait__inner', false]
  ];

  function reveal() {
    if (reduce || design || !('IntersectionObserver' in window)) return; /* tout reste visible */
    var els = [];
    function show(el) { el.classList.add('is-in'); }
    try {
      GROUPS.forEach(function (g) {
        var i = 0;
        document.querySelectorAll(g[0]).forEach(function (el) {
          if (el.classList.contains('ms-io')) return;
          el.classList.add('ms-io');
          if (g[1]) { el.style.setProperty('--ms-i', String(i % 4)); i += 1; } /* 4 temps maximum */
          els.push(el);
        });
      });
      if (!els.length) return;
      var vh = window.innerHeight || html.clientHeight;
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (!e.isIntersecting) return;
          show(e.target);
          io.unobserve(e.target);
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0 });
      els.forEach(function (el) {
        var r = el.getBoundingClientRect();
        if (r.bottom <= 0 || r.top < vh * 0.9) show(el); /* déjà à l'écran ou déjà passé : aucun clignotement */
        else io.observe(el);
      });
      html.classList.add('ms-ready'); /* APRÈS : les éléments déjà visibles portent déjà .is-in */
      /* un bloc atteint au clavier ou imprimé est toujours visible */
      document.addEventListener('focusin', function (e) {
        var b = e.target.closest && e.target.closest('.ms-io');
        if (b) show(b);
      });
      window.addEventListener('beforeprint', function () { els.forEach(show); });
    } catch (err) {
      html.classList.remove('ms-ready');
      els.forEach(show);
    }
  }

  /* ---------- 2. Nuancier vivant (blocks/sahari-coloris.liquid) ---------- */
  var lastPointer = 'mouse';
  var LINKS = 'a.product-card__link, a[ref="cardGalleryLink"], a[ref="productTitleLink"]';

  function dotOf(e) { return e.target && e.target.closest ? e.target.closest('.ms-sw') : null; }
  function cardOf(node) { return node.closest('product-card, .product-card'); }

  function layerOf(card) {
    var gallery = card.querySelector('.card-gallery');
    if (!gallery) return null;
    var layer = gallery.querySelector('.ms-sw__layer');
    if (!layer) {
      layer = document.createElement('img');
      layer.className = 'ms-sw__layer';
      layer.alt = '';
      layer.setAttribute('aria-hidden', 'true');
      layer.decoding = 'async';
      gallery.appendChild(layer);
    }
    return layer;
  }

  function setName(group, text) {
    var name = group.querySelector('.ms-sws__name');
    if (name) name.textContent = text;
  }

  function show(dot) { /* aperçu : la photo du coloris apparaît en fondu sur la carte */
    var card = cardOf(dot), group = dot.closest('.ms-sws');
    if (!card || !group) return;
    var layer = layerOf(card), src = dot.getAttribute('data-ms-src');
    if (!layer || !src) return;
    if (layer.getAttribute('src') !== src) {
      layer.classList.remove('is-on');
      layer.onload = function () { if (layer.getAttribute('src') === src) layer.classList.add('is-on'); };
      layer.src = src;
      if (layer.complete && layer.naturalWidth) layer.classList.add('is-on');
    } else {
      layer.classList.add('is-on');
    }
    setName(group, dot.getAttribute('data-ms-name') || '');
  }

  function rest(card) { /* retour au coloris épinglé (au doigt) ou au coloris par défaut */
    var group = card.querySelector('.ms-sws');
    if (!group) return;
    if (group.__pin) { show(group.__pin); return; }
    var layer = card.querySelector('.ms-sw__layer');
    if (layer) layer.classList.remove('is-on');
    var name = group.querySelector('.ms-sws__name');
    if (name) name.textContent = name.getAttribute('data-ms-default-name') || '';
  }

  function pin(dot) { /* au doigt : la carte entière mène au coloris choisi */
    var card = cardOf(dot), group = dot.closest('.ms-sws');
    group.__pin = dot;
    group.querySelectorAll('.ms-sw').forEach(function (d) { d.removeAttribute('aria-current'); });
    dot.setAttribute('aria-current', 'true');
    card.querySelectorAll(LINKS).forEach(function (a) { a.href = dot.href; });
    show(dot);
  }

  document.addEventListener('pointerdown', function (e) { lastPointer = e.pointerType || 'mouse'; }, true);
  document.addEventListener('pointerover', function (e) {
    if ((e.pointerType || 'mouse') === 'touch') return;
    var dot = dotOf(e); if (dot) show(dot);
  });
  document.addEventListener('pointerout', function (e) {
    var card = e.target.closest && cardOf(e.target);
    if (!card) return;
    if (!(e.relatedTarget && card.contains(e.relatedTarget))) { rest(card); return; }
    var from = dotOf(e), grp = from && from.closest('.ms-sws'); /* sortie d'une pastille vers l'image ou le titre : retour au coloris d'origine */
    if (grp && !grp.contains(e.relatedTarget)) rest(card);
  });
  document.addEventListener('focusin', function (e) { var dot = dotOf(e); if (dot) show(dot); });
  document.addEventListener('focusout', function (e) {
    var dot = dotOf(e), card = dot && cardOf(dot);
    if (card && !(e.relatedTarget && card.contains(e.relatedTarget))) rest(card);
  });
  document.addEventListener('click', function (e) {
    var dot = dotOf(e); if (!dot) return;
    if (lastPointer !== 'touch') return;                 /* souris, stylet, clavier : le lien mène à la variante */
    var group = dot.closest('.ms-sws');
    if (group && group.__pin === dot) return;            /* seconde touche sur la même pastille : on ouvre la fiche */
    e.preventDefault(); e.stopPropagation();
    pin(dot);
  }, true);

  if (document.readyState !== 'loading') reveal();
  else document.addEventListener('DOMContentLoaded', reveal);
})();